import UploadIcon from '@mui/icons-material/CloudUpload';
import RemoveIcon from '@mui/icons-material/DeleteOutline';
import { Box } from '@mui/material';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { FileInputProps, FileInput as FileInputRA, useNotify, useTranslate } from 'react-admin';

import { DOCUMENTS_UPLOAD_FILE_MAX_SIZE } from '@Common/constants/documents';

// React-admin FileInput does not display errors (like file too big)
export const FileInput = (props: FileInputProps) => {
  const notify = useNotify();
  const translate = useTranslate();

  return (
    <FileInputRA
      sx={{
        '.RaFileInputPreview-removeIcon': {
          color: 'grey !important',
          fontSize: 'large',
        },
        '.MuiLink-root': {
          textDecoration: 'none',
        },
        ...(props.disabled && {
          '.RaFileInput-dropZone': {
            cursor: 'default',
            opacity: 0.5,
          },
        }),
      }}
      maxSize={DOCUMENTS_UPLOAD_FILE_MAX_SIZE}
      removeIcon={RemoveIcon}
      {...props}
      options={{
        disabled: props.disabled,
        onDropRejected: (result) => {
          notify('resources.bo_common.file_upload.error', {
            type: 'error',
            messageArgs: {
              error: result.flatMap((entry) =>
                entry.errors.map((error) => error.message).join('\n'),
              ),
            },
            multiLine: true,
          });
        },
        ...props.options,
      }}
      placeholder={
        <Box
          sx={{
            padding: '15px',
          }}>
          <UploadIcon />
          <br />
          {translate('general.upload.dropzone')}
        </Box>
      }
    />
  );
};
